import { render, staticRenderFns } from "./SalesPromoSupplier.vue?vue&type=template&id=96bf1294&"
import script from "./SalesPromoSupplier.vue?vue&type=script&lang=js&"
export * from "./SalesPromoSupplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports